import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../amplify-client';
import { GuennieRating } from '../components/GuennieRating';
import { SpaghettiDivider } from '../components/SpaghettiDivider';
import { useRolle } from '../auth/useRolle';

type Kartenpunkt = {
  id: string;
  name: string;
  ort: string;
  anzahlTests: number;
  avgGesamtGuennies?: number | null;
};

export function Uebersicht() {
  const { anzeigename, darfTesten } = useRolle();
  const [top, setTop] = useState<Kartenpunkt[]>([]);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    client.queries
      .karteEisdielen()
      .then(({ data }) => {
        const liste = (data ?? []).filter(Boolean) as Kartenpunkt[];
        liste.sort((a, b) => (b.avgGesamtGuennies ?? 0) - (a.avgGesamtGuennies ?? 0));
        setTop(liste.slice(0, 3));
      })
      .catch((e) => setFehler(String(e?.message ?? e)));
  }, []);

  return (
    <div className="container">
      <p className="label">Aus der Presse</p>
      <h1>Willkommen, {anzeigename ?? 'Verkoster'}</h1>
      <SpaghettiDivider />

      <h2>Empfehlungen der Redaktion</h2>
      {fehler ? <p className="hinweis">Konnte die Übersicht nicht laden: {fehler}</p> : null}
      {top.length === 0 && !fehler ? (
        <p style={{ color: 'var(--espresso-70)' }}>
          Noch keine veröffentlichten Verkostungen. {darfTesten ? 'Ein Auftrag für die Redaktion.' : ''}
        </p>
      ) : null}
      <div
        style={{
          display: 'grid',
          gap: '1rem',
          gridTemplateColumns: 'repeat(auto-fill, minmax(15rem, 1fr))',
        }}
      >
        {top.map((e) => (
          <Link key={e.id} to={`/app/eisdielen/${e.id}`} className="karte" style={{ textDecoration: 'none' }}>
            <strong style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem' }}>{e.name}</strong>
            <div style={{ color: 'var(--espresso-70)', fontSize: '0.9rem' }}>{e.ort}</div>
            <div style={{ marginTop: '0.5rem' }}>
              <GuennieRating wert={e.avgGesamtGuennies ?? null} groesse="sm" />
            </div>
            <div className="label" style={{ marginTop: '0.35rem' }}>
              {e.anzahlTests} Verkostung{e.anzahlTests === 1 ? '' : 'en'}
            </div>
          </Link>
        ))}
      </div>

      <p style={{ marginTop: '2rem' }}>
        <Link to="/app/karte" className="btn btn-sekundaer">
          Zur Karte
        </Link>
      </p>
    </div>
  );
}
